export const REACT_QUERY_PERSISTER_KEY = 'REACT_QUERY_OFFLINE_CACHE';
